'use client';

import { createContext, ReactNode, useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { Envs } from '@ae/envs';
import { useLocale, useMe } from '@ae/shared';

export const getGtmSectionByUrl = (url: string) => {
  switch (true) {
    case /\/guest/.test(url):
    case /\/guest-staging/.test(url):
    case /localhost:3000/.test(url):
    case /loc.ardennes-etape.com:3000/.test(url):
      return 'client_account';
    case /\/experience\//.test(url):
    case /\/experience-preprod\//.test(url):
      return 'aex';
    default: {
      return 'ecommerce';
    }
  }
};

export const GlobalTagContext = createContext({
  email_address: '',
  user_id: '',
  page_language: '',
  login_status: '',
  page_location: '',
  website_section: '',
});

type Props = {
  children: ReactNode;
};

export const TagProvider = ({ children }: Props) => {
  const [isClient, setIsClient] = useState(false);
  const { data: user } = useMe();
  const locale = useLocale();

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    TagManager.initialize({
      gtmId: Envs.gtmId,
    });
  }, []);

  return (
    <GlobalTagContext.Provider
      value={{
        email_address: user?.email ?? '',
        user_id: user?.id?.toString() ?? '',
        page_language: locale,
        login_status: user?.email ? 'logged_in' : 'guest',
        page_location: isClient ? window.location.href : '',
        website_section: getGtmSectionByUrl(
          isClient ? window.location.href : ''
        ),
      }}
    >
      {children}
    </GlobalTagContext.Provider>
  );
};
